import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { getPreferredStopName, normalizeStopDescription } from "@catchy/app-core";
import FavouriteIndicator from "./FavouriteIndicator";
import StopMarker from "@catchy/assets/svgs/stop-mono-lg.svg";
export function getStopTypeColorClass(stopType) {
  switch (stopType) {
    case "train":
      return "text-green-500";
    case "cable_car":
      return "text-red-500";
    case "ferry":
      return "text-blue-500";
    case "bus":
    default:
      return "text-orange-400";
  }
}
export default function StopRow(t0) {
  const $ = _c(37);
  const {
    distance,
    isFavourite: t1,
    stop_name,
    stop_code,
    stop_description,
    preferredStopNames,
    stop_id,
    type,
    stop_type,
    onStopSelect,
    resolveStopType
  } = t0;
  const isFavourite = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== preferredStopNames || $[1] !== stop_code || $[2] !== stop_id) {
    t2 = getPreferredStopName(preferredStopNames, stop_id, stop_code);
    $[0] = preferredStopNames;
    $[1] = stop_code;
    $[2] = stop_id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const preferredName = t2;
  let t3;
  if ($[4] !== stop_description) {
    t3 = normalizeStopDescription(stop_description);
    $[4] = stop_description;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const description = t3;
  let t4;
  if ($[6] !== resolveStopType || $[7] !== stop_id || $[8] !== stop_type || $[9] !== type) {
    t4 = resolveStopType ? resolveStopType({
      stop_id,
      stop_type,
      type
    }) : stop_type || type;
    $[6] = resolveStopType;
    $[7] = stop_id;
    $[8] = stop_type;
    $[9] = type;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const stopType = t4;
  let t5;
  if ($[11] !== onStopSelect) {
    t5 = event => {
      if (typeof onStopSelect !== "function") {
        return;
      }
      event.preventDefault();
      onStopSelect();
    };
    $[11] = onStopSelect;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const handleClick = t5;
  const t6 = `/stop/${stop_id}`;
  let t7;
  if ($[13] !== isFavourite || $[14] !== stopType) {
    t7 = isFavourite ? <FavouriteIndicator /> : <StopMarker className={`${getStopTypeColorClass(stopType)} ml-[16px] mr-[16px] mt-0.5 h-[1.125rem] w-3 flex-shrink-0`} />;
    $[13] = isFavourite;
    $[14] = stopType;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = preferredName || stop_name;
  let t9;
  if ($[16] !== t8) {
    t9 = <span>{t8}</span>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== preferredName || $[19] !== stop_name) {
    t10 = preferredName && preferredName !== stop_name ? <span className="text-sm leading-none opacity-80">{stop_name}</span> : null;
    $[18] = preferredName;
    $[19] = stop_name;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== description) {
    t11 = description ? <span className="text-sm leading-none opacity-60">{description}</span> : null;
    $[21] = description;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11 || $[25] !== t9) {
    t12 = <span className="flex min-w-0 flex-col gap-y-1">{t9}{t10}{t11}</span>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== distance) {
    t13 = distance && <span className="shrink-0 text-right opacity-60">{distance}</span>;
    $[27] = distance;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t12 || $[30] !== t13) {
    t14 = <span className="flex min-w-0 flex-1 items-start justify-between gap-3 text-pretty">{t12}{t13}</span>;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== handleClick || $[33] !== t14 || $[34] !== t6 || $[35] !== t7) {
    t15 = <Link href={t6} onClick={handleClick} className="transition-colors flex flex-nowrap items-start px-[20px] py-5 text-lg leading-tight outline-none ring-blue-500/50 duration-150 hover:bg-zinc-400/10 focus-visible:ring focus-visible:ring-inset active:bg-zinc-400/10 sm:rounded-lg">{t7}{t14}</Link>;
    $[32] = handleClick;
    $[33] = t14;
    $[34] = t6;
    $[35] = t7;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  return t15;
}